import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { Tooltip, Typography } from 'antd';

type OverflowTooltipTextProps = {
  children: React.ReactNode;
  className?: string;
  title?: React.ReactNode;
};

const OverflowTooltipText: React.FC<OverflowTooltipTextProps> = ({
  children,
  className,
  title,
}) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const checkOverflow = useCallback(() => {
    const element = textRef.current;
    if (!element) return;

    setIsOverflowing(element.scrollWidth > element.clientWidth);
  }, []);

  useLayoutEffect(() => {
    checkOverflow();

    const element = textRef.current;
    if (!element || typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', checkOverflow);
      return () => window.removeEventListener('resize', checkOverflow);
    }

    const resizeObserver = new ResizeObserver(checkOverflow);
    resizeObserver.observe(element);
    window.addEventListener('resize', checkOverflow);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', checkOverflow);
    };
  }, [children, checkOverflow]);

  return (
    <Tooltip
      overlayClassName='inventory-tooltip'
      title={
        isOverflowing ? (
          <div className='inventory-tooltip-content inventory-text-tooltip-content'>
            <span className='inventory-tooltip-label'>{title}</span>
          </div>
        ) : null
      }
      placement='top'
    >
      <Typography.Text ref={textRef} ellipsis className={className}>
        {children}
      </Typography.Text>
    </Tooltip>
  );
};

export default OverflowTooltipText;
